<script>
  import router from "page";
  import Header from "./Components/Header.svelte";
  import Navbar from "./Components/Navbar.svelte";
  import Progress from "./Components/Progress.svelte";
  import Custom from "./Routes/backtest/Custom.svelte";
  import Report from "./Routes/backtest/Report.svelte";
  import Login from "./Routes/auth/Login.svelte";
  import { users } from "./stores";
  import auth from "./firebase";

  let user_value;
  let showloginpage = false;

  const unsubscribe = users.subscribe((value) => {
    user_value = value;
  });

  auth.onAuthStateChanged((user) => {
    if (user) {
      users.set({ ...$users, loggedIn: true });
    } else {
      showloginpage = true;
    }
  });
  let mode;

  let setMode;

  let page;
  mode = localStorage.getItem("mode");
  function changeMode() {
    mode = localStorage.getItem("mode");
    console.log(mode);
  }

  $: if (mode == "dark") {
    setMode = "theme-dark";
  } else {
    setMode = "";
  }

  router("/custom", () => (page = Custom));
  router("/reports", () => (page = Report));

  router.start();
</script>

<div class="antialiased {setMode}">
  {#if user_value.loggedIn == true}
    <div class="wrapper">
      <div class="sticky-top">
        <Header on:mode={changeMode} />
        <Navbar />
      </div>
      <div class="page-wrapper">
        <svelte:component this={page} />
      </div>
    </div>
  {/if}
  {#if user_value.loggedIn == false}
    {#if showloginpage == true}
      <Login />
    {/if}
    {#if showloginpage == false}
      <Progress />
    {/if}
  {/if}
</div>

<style>
</style>
